import { Campaign } from '../types/campaign.types';
import { FORM_STATUS } from '../types/form-status';

import { privateClient } from './api-client';

export const sharedApi = {
  campaigns: async () => {
    const campaigns = await privateClient.get('campaigns/').json<Campaign[]>();

    return campaigns.sort((a, b) => a.year - b.year);
  },
  cgu: async () => {
    const cgu = await privateClient.get('accounts/tutorial/').json<{
      file: string;
    }>();

    return cgu;
  },
  uploadYieldMap: ({ file, farm, yield_float }: UploadYieldMapParams) => {
    const data = new FormData();
    data.append('file', file);
    data.append('farm', farm.toString());
    data.append('yield_float', yield_float.toString());

    return privateClient
      .post('upload_yield_map/', {
        body: data,
      })
      .json<{ status: string }>();
  },
  getComputationStatus: async (requestId: number) => {
    return privateClient.get(`computation_requests/${requestId}/`).json<{
      id: number;
      status: FORM_STATUS;
      instance_id: number;
    }>();
  },
};

interface UploadYieldMapParams {
  file: File;
  farm: number;
  yield_float: number;
  comment: string;
}
